import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from "@angular/core";
import { ResponseType } from "src/utils/enums";
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";

@Component({
  selector: "app-survey-button",
  templateUrl: "./survey-button.component.html",
  styleUrls: ["./survey-button.component.scss"],
  standalone: false
})

export class SurveyButtonComponent implements OnChanges, OnInit, OnDestroy {
  @Input() questionDetails: any;
  @Input() surveyData: any;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  activeIndex: number;
  showMaskImage: boolean;
  showHeaderImage: boolean;

  constructor(private infoDialog: MatDialog) {
    console.log("Survey button component loaded.");
  }

  ngOnInit(): void {
    this.showMaskImage = this.getImageDisplayValue("ShowMaskImage");
    this.showHeaderImage = this.getImageDisplayValue("ShowHeaderImage");
  }

  ngOnDestroy(): void {
  }

  getImageDisplayValue(surveyDataProperty: string): boolean {
    return this.questionDetails.hasOwnProperty(surveyDataProperty) ? 
              this.questionDetails[surveyDataProperty] :
              false;
  }

  answerSelected(answer: any, index: number): void {
    answer.Index = index;

    // Ensure description field is initialized.
    if (answer.FreeText && answer.Description === undefined){
      answer.Description = "";
    }

    if (answer.FreeText && answer.Description?.trim() !== "") {
      answer.ResponseType = ResponseType.FreeText;
      answer.Description = answer.Description?.trim();
    }
    this.answerSelectedEvent.emit(answer);
  }

  ngOnChanges(): void {
    if (this.questionDetails.hasOwnProperty("SelectedAnswer")) {
      this.activeIndex = this.questionDetails.SelectedAnswer.Index;
    }
    else {
      this.activeIndex = -1;
    }
    this.showHeaderImage = this.getImageDisplayValue("ShowHeaderImage");
  }

  displayInfoModal(): void {
    const dialogRef = this.infoDialog.open(InfoDialogComponent, {
      data: {dialogConfig: this.questionDetails.InfoDialog}
    })
  }
}
